function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSms = function SvgSms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.fill,
    fillRule: "evenodd",
    d: "M12.585 5.75c-1.008 0-1.952.183-2.813.62h-.004a5.86 5.86 0 0 0-3.24 5.241v.002a5.75 5.75 0 0 0 .62 2.615.75.75 0 0 1 .042.576l-1.004 3.01 3.01-1.003a.75.75 0 0 1 .576.042c.81.41 1.706.622 2.614.619h.003a5.86 5.86 0 0 0 5.24-3.24l.002-.004c.436-.861.619-1.805.619-2.812 0-1.45-.658-2.92-1.702-3.964-1.043-1.043-2.514-1.702-3.963-1.702m-3.489-.72c1.113-.563 2.298-.78 3.489-.78 1.883 0 3.726.844 5.024 2.142s2.141 3.14 2.141 5.024c0 1.19-.218 2.376-.78 3.488a7.36 7.36 0 0 1-6.58 4.068h.002-.002a7.25 7.25 0 0 1-3.007-.643l-4.146 1.383a.75.75 0 0 1-.949-.95l1.383-4.145a7.25 7.25 0 0 1-.643-3.007v-.002.002a7.36 7.36 0 0 1 4.068-6.58m0 0h-.002.004z",
    clipRule: "evenodd"
  }));
};
export default SvgSms;